var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { dasherize } from '@ember/string';
import { pluralize } from 'ember-inflector';
import RESTAdapter from '@ember-data/adapter/rest';
import { baseRpcUrl } from '@square/dashboard-utilities/utils/url';
import { getCsrfToken } from '@square/dashboard-utilities/utils/csrf';
import { inject as service } from '@ember/service';
let Menu = (_class = class Menu extends RESTAdapter {
  constructor(args) {
    super(args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _defineProperty(this, "useFetch", void 0);
    _defineProperty(this, "namespace", 'v2');
    _defineProperty(this, "host", baseRpcUrl('', true));
    _defineProperty(this, "headers", {
      'X-CSRF-Token': getCsrfToken()
    });
    this.useFetch = false;
  }
  ajaxOptions(url, type, options) {
    return super.ajaxOptions(url, type, {
      xhrFields: {
        withCredentials: true
      },
      ...options
    });
  }
  pathForType(type) {
    return pluralize(dasherize(type));
  }
  async batch(batchRequest) {
    const url = `${this.buildURL('menu-sync/menu')}/batch`;
    const response = await this.ajax(url, 'POST', {
      data: {
        create: batchRequest.create.map(r => r.serialize()),
        update: batchRequest.update.map(r => r.serialize({
          includeId: true
        })),
        delete: batchRequest.delete.map(r => r.serialize({
          includeId: true
        })),
        trigger_sync: batchRequest.triggerSync
      }
    });
    for (const record of batchRequest.create) {
      record.unloadRecord();
    }
    for (const record of batchRequest.update) {
      for (const menuHourRecord of record.menuHours.toArray()) {
        menuHourRecord.unloadRecord();
      }
    }
    for (const record of batchRequest.delete) {
      record.unloadRecord();
    }
    if (response.menus && response.menus.length > 0) {
      for (const menu of response.menus) {
        const modelClass = this.store.modelFor('menu-sync/menu');
        const serializer = this.store.serializerFor('menu-sync/menu');
        const normalized = serializer.normalize(modelClass, menu);
        this.store.push(normalized);
      }
    }
    return response;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Menu as default };